<div class="rangePicker" id="rangePicker" (clickOutside)="closeRangePicker($event)" appClickOutsideComponent>
  <div class="range-picker-header">
    <div class="tile-container">
      <nb-icon class="icon" icon="calendar" pack="icomoon"></nb-icon>
      <h1>{{ 'view_translations.date_range' | translate }}</h1>
      <div class="d-flex ms-2" *ngIf="isComparePicker">
        <div
          class="tooltip-button tool-tip"
          ngbTooltip="{{ 'view_translations.statistics_max_possible_date_range' | translate : {value: maxDateRange } }}"
          placement="top-right"
          tooltipClass="my-configurations-tooltip">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
      </div>
    </div>
    <div class="close-button" (click)="closeRangePicker()">
      <nb-icon icon="cross" pack="icomoon"></nb-icon>
    </div>
  </div>
  <div class="range-picker-main-container">
    <div class="left-container">
      <app-statistics-date-picker
        (emitSelectedPeriod)="setSelectedPeriodDates($event)"
        (setSelectedPeriod)="setSelectedSidebarPeriod($event, true)"
        [selectedPeriod]="selectedPeriod"
        [dateRanges]="dateRanges"
        [currentDatePicker]="currentDatePicker">
      </app-statistics-date-picker>
      <div class="range-picker-footer">
        <div class="d-flex flex-column">
          <div class="error-text">
            <small *ngIf="rangeTooWideCompare && maxDateRange" class="form-text text-danger">
              {{ 'view_translations.statistics_max_possible_date_range' | translate : {value: maxDateRange } }}
            </small>
            <small *ngIf="isDateRangeTooWide" class="form-text text-danger"> {{ 'view_translations.statistics_max_possible_custom_date_range' | t }} </small>
          </div>
          <div class="d-flex align-items-center">
            <app-primary-button
              class="datepickerPrimaryBtn"
              [buttonText]="'apply'"
              [icon]="''"
              [iconSize]="12"
              [background]="'orange'"
              [disabled]="!selectedPeriodDates?.dateFrom || !selectedPeriodDates?.dateTo || rangeTooWideCompare || isDateRangeTooWide"
              (emitAction)="emitDateRange()">
            </app-primary-button>
            <app-secondary-button
              class="datepickerSecBtn"
              [iconSize]="11"
              [text]="'cancel'"
              [icon]=""
              [largeButton]="false"
              [backgroundColor]="'white'"
              (emitAction)="closeRangePicker()">
            </app-secondary-button>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-container">
      <app-statistics-date-picker-sidebar
        [currentDatePicker]="currentDatePicker"
        [selectedPeriod]="selectedPeriod"
        (setSelectedPeriod)="setSelectedSidebarPeriod($event)">
      </app-statistics-date-picker-sidebar>
    </div>
  </div>
</div>
